export default "__VITE_ASSET__DoDfbVg8__"